let getters = {
  getToken (state) {
    return state.token
  },
  getUserId (state) {
    return state.contactId
  },
  getLoading (state) {
    return state.isLoading
  },
  getDetailLoading (state) {
    return state.isDetailLoading
  },
  getMessageLoading (state) {
    return state.isMessageLoading
  },
  getAllQuestionCount (state) {
    return state.allQuestionCount
  },
  getQuestionDetail (state) {
    return state.questionDetail
  },
  getMessageDetail (state) {
    return state.messageDetail
  },
  getRelatedQuizDetail (state) {
    return state.relatedQuizDetail
  },
  getQuestionPage (state) {
    return state.questionPage
  },
  getPageCount (state) {
    return state.pageCount
  },
  getPageSize (state) {
    return state.pageSize
  },
  getCommentPageSize (state) {
    return state.commentPageSize
  },
  getRedPoint (state) {
    return state.redPoint
  },
  getMaxPageCount (state) {
    return state.MAX_PAGE_COUNT
  },
  imgsNeedToPreview_Items (state) {
    var temp = []
    if (state.previewImg.imgSrcNeedToPreview) {
      state.previewImg.imgSrcNeedToPreview.forEach((imgSrc, index) => {
        if (imgSrc === state.previewImg.currImgNeedToPreview) {
          state.imgPreviewStartIndex = index
        }
        if (imgSrc.indexOf('base64') !== -1 || imgSrc.indexOf('https') !== -1) {
          temp.push({src: imgSrc, w: 0, h: 0})
        } else {
          temp.push({src: 'https://www.erplus.co/image' + imgSrc, w: 0, h: 0})
        }
      })
    }
    return temp
  }
}

export default getters



// WEBPACK FOOTER //
// ./src/vuex/getters.js